export default __webpack_public_path__ + "static/media/landing-Main-vector.2e855ddb.svg";